import CssVariables from './CssVariables.js';
var GlobalTokens = {
  borderRadius: 2,
  colorInfo: CssVariables['--up-blue-40'],
  colorLink: CssVariables['--up-blue-40'],
  colorError: CssVariables['--up-red-50'],
  fontFamily: CssVariables['--font-family'],
  colorBorder: CssVariables['--up-black-10'],
  colorPrimary: CssVariables['--up-blue-40'],
  colorSuccess: CssVariables['--up-green-50'],
  colorWarning: CssVariables['--up-yellow-50'],
  colorTextBase: CssVariables['--up-black-80'],
  colorTextDisabled: CssVariables['--up-black-50'],
  colorTextPlaceholder: CssVariables['--up-black-50'],
  colorBgContainerDisabled: CssVariables['--up-black-5'],
  controlHeightSM: 32,
  controlHeight: 40,
  controlHeightLG: 48
};
var ComponentTokens = {
  Button: {
    fontWeight: 600,
    paddingBlockSM: 6,
    paddingInlineSM: 16,
    contentFontSizeSM: 14,
    paddingBlock: 8,
    paddingInline: 16,
    contentFontSize: 16,
    paddingBlockLG: 12,
    paddingInlineLG: 24,
    contentFontSizeLG: 16,
    borderColorDisabled: CssVariables['--up-black-20']
  },
  Form: {
    labelColor: CssVariables['--up-black-60'],
    labelRequiredMarkColor: CssVariables['--up-black-60']
  },
  Input: {
    addonBg: CssVariables['--up-black-5'],
    activeShadow: 'none',
    errorActiveShadow: 'none',
    warningActiveShadow: 'none'
  },
  Select: {
    optionSelectedFontWeight: 600,
    optionSelectedColor: CssVariables['--up-blue-40']
  },
  Table: {
    rowHoverBg: CssVariables['--up-blue-5'],
    headerBg: CssVariables['--up-black-5'],
    headerColor: CssVariables['--up-black-50'],
    cellPaddingBlock: 12,
    rowSelectedBg: CssVariables['--up-black-0'],
    rowSelectedHoverBg: CssVariables['--up-blue-5']
  }
};
export { ComponentTokens, GlobalTokens };
//# sourceMappingURL=AntdToken.js.map
